





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getAllTree } from '@/api/api'
@Component({
  name: 'tree-data'
})
export default class extends Vue {
  @Prop() private tipshow!: string
  @Prop() private orgdata!: []
  @Prop() private activeNames!: string
  private treeData = []
  private active = ''
  private orgList = []
  private defaultProps = {
    children: 'children',
    name: 'name',
    id: 'id'
  }
  @Watch('activeNames', { immediate: true })
  getActive(val: any) {
    this.active = val
  }
  @Watch('orgdata')
  getOrg(val: any) {
    if (val !== null && val !== undefined) {
      this.$nextTick(() => {
        (this.$refs as any).rightsTree.setCheckedKeys(val)
      })
    } else {
      if (this.$refs.rightsTree !== undefined) {
        (this.$refs as any).rightsTree.setCheckedKeys([])
      }
    }
  }
  created() {
    this.getList()
  }
  // 功能
  // 获取数据
  private async getList() {
    const { data } = await getAllTree({})
    this.treeData = data.data
  }
  // ui
  handleNodeClick(node: any, data: any, value: any) {
    this.$emit('getOrgList', data.checkedKeys)
  }
  handleClick(item: any) {
    const parent = {
      code: item.name,
      val: Number(item.index) + 1
    }
    this.$emit('gettype', parent)
  }
}
